export default __webpack_public_path__ + "static/media/asset-2.4ffae46a.svg";